<template>
    <div class="account-errors" v-if="errors.length">
        <p class="error" v-for="error in errors" :key="error">
            <i class="fa fa-exclamation-triangle"/>
            {{ error }}
        </p>
    </div>
</template>

<script>
    export default {
        name: 'errors',

        props: {
            errors: {
                type: Array,
                default () {
                    return [];
                },
            },
        },
    }
</script>
